import type { ViewType } from '@lighthouse/core'

export const KANBAN_PAGE_SIZE = 200

export const CALENDAR_PAGE_SIZE = 500

export const WEEK_CALENDAR_PAGE_SIZE = 100

export const MONTH_CALENDAR_PAGE_SIZE = 500

export const VIEW_PAGE_SIZE = 10

export const VIEW_BLOCK_NAME_MAP: Record<ViewType, string> = {
    advancedTable: '高级表格',
    calendar: '日历',
    table: '表格',
    list: '列表',
    gallery: '画廊',
    kanban: '看板',
    custom: '自定义视图'
}
